import { render } from "./IconBanners.vue?vue&type=template&id=4abd4a92"
import script from "./IconBanners.vue?vue&type=script&lang=js"
export * from "./IconBanners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__